<div class="bcg p-4 ">
    <div class="row">
        <div class="col-lg-7 col-sm-7 col-md-7">
            <p class="nav_link_cat ms-1  flex_row">
                <span class="clickable" (click)="gotoDashboard()">Dashboard</span>
                <span [style.font-weight]="'bold'"> >> </span>
                <span>Wallet</span>
                <span [style.font-weight]="'bold'"> >> </span>
                <span>Amount Balance</span>


            </p>
        </div>
        <div class="col-lg-2 col-sm-2 col-md-2 "></div>
        <div class="col-lg-3 col-sm-3 col-md-3 overlay text-right">
            <app-select-branch></app-select-branch>
        </div>
    </div>

    <div class="card card_outLine mt-3">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-6 col-sm-6 col-md-6">
                    <h5 class="title_five">State wise amount balance</h5>
                    <p class="card-text text_p ">Amount available to the User State wise</p>
                </div>
                <div class="col-lg-6 col-sm-6 col-md-6 text-right custom_button">
                    <p-button label="Add New Wallet" icon="pi pi-plus-circle"
                        [routerLink]="['/doqfy/wallet/add-state-wallet']" styleClass="p-button-sm-outline"></p-button>
                    <p-button class="ms-1" label="Back" [routerLink]="['/doqfy/dashboard']"
                        styleClass="p-button-sm-outline"></p-button>

                </div>
            </div>
        </div>
    </div>
    <div class="card card_outLine mt-3">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-6 col-sm-6 col-md-6">
                    <h5 class="title_five">Total Deposit : ₹ {{amountbalance}}</h5>
                </div>
                <div class="col-lg-2 col-sm-2 col-md-2 offset-2 overlay_1">
                    <app-dropdown class="custom-dropdown text-left" placeholder="Select State" [options]="states"
                     optionLabel="state_name" optionValue="id" (onChange)="onStateChanage($event)" [showClear]="true"></app-dropdown>

                </div>
                <div class="col-lg-2 col-sm-2 col-md-2 text-right">
                    <app-column-chooser [table]="dataTable"></app-column-chooser>
                </div>
            </div>
            <div class="row m-2">
                <app-data-table
                    #dataTable
                    [columnChooser]="true"
                    [columns]="columns"
                    [data]="amountbalanceData"
                    [totalRecords]="totalRecords"
                    [rows]="1"
                    [paginator]="true"
                    [lazy]="true"
                    [analyticsTab]="'State Wise Amount Balance'"
                    emptyMessage="No Records Found"
                    (pageChange)="onPageChange($event)"
                    (rowClick)="viewStateWallet($event)">
                    <ng-template appTableCell="denomination" let-row>
                        ₹ {{ row.denomination }}
                    </ng-template>

                    <ng-template appTableCell="balance" let-row>
                        ₹ {{ row.balance }}
                    </ng-template>

                    <ng-template appTableCell="action" let-row>
                        <div appRowActionStop>
                            <a class="viewmore" appIconAction [routerLink]="['/doqfy/wallet/expenditure', row.id]"><i
                                    class="pi pi-eye" pTooltip="View Branch Wallet"></i></a>
                            <a class="viewmore" (click)="openAddBalance(addBalanceModal, row)"><i
                                    class="pi pi-plus" pTooltip="Add Balance"></i></a>
                        </div>
                    </ng-template>
                </app-data-table>
            </div>


        </div>
    </div>


</div>

<ng-template #addBalanceModal let-modal>
    <div class="modal-header">
        <strong>Add Balance</strong>
        <button style="margin-left: 250px;" type="button" class="close" aria-label="Close"
            (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="container">
            <div class="d-flex justify-content-between mb-3">
                <div>
                    <span class="title_header">Balance Details</span>
                </div>
                <div>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <div class="r1">State:<span class="r1s">{{selectedStateWallet.state.state_name}}</span></div>
                </div>
                <div class="col">
                    <div class=" r1">Denomination: <span class="r1s">{{selectedStateWallet.denomination}}</span></div>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <div class=" r1 ">Stamp Type: <span class="r1s">{{selectedStateWallet.stamp_type}}</span></div>
                </div>
                <div class="col">
                    <div class=" r1">Current Balance: <span class="r1s">{{selectedStateWallet.balance}}</span></div>
                </div>
            </div>

            <form [formGroup]="addBalanceForm">
                <div class="row">
                    <div class="col-lg-4 col-sm-4 col-md-4">
                        <span class="r1">Enter Amount </span><span class="color_red">*</span>
                        <input type="number" class="form-control branchAmount" [(ngModel)]="enteredBalance"
                            placeholder="Enter Amount" pInputText (keypress)="numberOnly($event)"
                            formControlName="amount">
                        <span class="p-error" style="font-size: 0.5rem;" *ngIf="!isBalanceAdded">*Enter amount </span>
                    </div>
                </div>
            </form>

            <div class="row mt-2">
                <div class="col-lg-2 col-sm-2 col-md-2 offset-10">
                    <div class="text-right custom_button">
                        <p-button label="Add" (click)="addBalance()" styleClass="p-button-sm-outline">
                        </p-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<div class="toast_display_layer">
    <p-toast></p-toast>
</div>